import React, { useEffect, useState } from 'react';
import { DocumentServices } from '../../services/DocumentService';
import { TipoPostulacionService } from '../../services/TipoPostulacionService';
import { useNavigate, useParams } from 'react-router-dom';
import Preloader from '../../components/Preloader';
import { PostulanteService } from '../../services/PostulanteService';
import { toast } from 'react-toastify';
import { EstadoPostulanteService } from '../../services/EstadoPostulante';
import { ClienteService } from '../../services/ClienteService';
import { Search } from 'lucide-react';
import LocationDropdowns from '../../components/LocationDropdowns';

const EntrevistaForm = ({ token }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [form, setForm] = useState({
        tipoPostulacion: "",
        nombre_referido: "",
        apellidoPaterno: "",
        apellidoMaterno: "",
        nombres: "",
        tipoDocumento: "",
        numeroDocumento: "",
        telefono: "",
        email: "",
        edad: "",
        comentario_entrevista: "",
        estado_postulante: "",
        fechaNacimiento: "",
        departamento: "",
        provincia: "",
        distrito: "",
        direccion: "",
    });
    const [tiposPostulacion, setTiposPostulacion] = useState([]);
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState("");
    const [estados, setEstados] = useState([]);
    const [locationData, setLocationData] = useState({
        department: "",
        province: "",
        district: "",
        zone: "",
    });

    const cargarEStados = async () => {
        try {
            const response = await EstadoPostulanteService.getEstadoPostulacion(token);
            const estadosPermitidos = [2, 3, 4, 5];
            const estadosFiltrados = response.filter((estado) =>
                estadosPermitidos.includes(estado.id)
            );
            setEstados(estadosFiltrados);
        } catch (error) {
            console.error("Error al cargar perfiles:", error);
        }
    };

    const cargarTipoDocumentos = async () => {
        try {
            const response = await DocumentServices.getDocuments(token);
            // Filtrar los que NO contienen "RUC"
            const documentosFiltrados = (response || []).filter(
                (doc) =>
                    doc.description && !doc.description.toUpperCase().includes("RUC")
            );

            setTiposDocumentos(documentosFiltrados);
        } catch (error) {
            console.error("Error al cargar tipos de Documentos:", error);
        }
    };

    const cargarTipoPostulacion = async () => {
        try {
            const tipos = await TipoPostulacionService.getTipoPostulacion(token);
            setTiposPostulacion(tipos || []);
        } catch (error) {
            console.error("Error al cargar tipos de Documentos:", error);
        }
    };

    useEffect(() => {
        cargarTipoDocumentos();
        cargarTipoPostulacion();
        cargarEStados();
        fetchPostulantes();
    }, []);

    const handleBackToList = () => {
        navigate("/admin/reclutamiento?tab=nuevo");
    };

    const validateNumericInput = (value) => {
        return value.replace(/[^0-9]/g, "");
    };

    const handleDepartmentChange = (value) => {
        setLocationData((prev) => ({
            ...prev,
            department: value,
            province: "",
            district: "",
            zone: "",
        }));
        // Sincronizar con form
        setForm((prev) => ({
            ...prev,
            departamento: value,
            provincia: "",
            distrito: "",
            region: "",
        }));
    };

    const handleProvinceChange = (value) => {
        setLocationData((prev) => ({
            ...prev,
            province: value,
            district: "",
            zone: "",
        }));
        // Sincronizar con form
        setForm((prev) => ({
            ...prev,
            provincia: value,
            distrito: "",
            region: "",
        }));
    };

    const handleDistrictChange = (value) => {
        setLocationData((prev) => ({
            ...prev,
            district: value,
            zone: "",
        }));
        // Sincronizar con form
        setForm((prev) => ({
            ...prev,
            distrito: value,
            region: "",
        }));
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        const iso = date.toISOString();
        return iso.split('T')[0]; // devuelve YYYY-MM-DD
    };

    const fetchPostulantes = async () => {
        setLoading(true);
        try {
            const postulanteData = await PostulanteService.fetchPostulanteById(token, id);

            if (postulanteData?.id_estado_postulante !== 2) {
                navigate('/admin/reclutamiento?tab=nuevo');
                return;
            }

            if (postulanteData) {
                const safeValue = (value) => value != null ? value : '';
                const { nombre, apellidoPaterno, apellidoMaterno } = dividirNombre(postulanteData.nombre_referido);
                setForm({
                    tipoPostulacion: postulanteData?.id_tipo_postulacion ?? '',
                    nombres: postulanteData.nombre ? postulanteData.nombre : nombre,
                    apellidoPaterno: postulanteData.apellidoPaterno ? postulanteData.apellidoPaterno : apellidoPaterno,
                    apellidoMaterno: postulanteData.apellidoMaterno ? postulanteData.apellidoMaterno : apellidoMaterno,
                    tipoDocumento: postulanteData?.id_tipo_documento ?? '',
                    numeroDocumento: postulanteData?.numero_documento ?? '',
                    telefono: postulanteData?.telefono ?? '',
                    email: postulanteData?.email ?? '',
                    edad: postulanteData?.edad ?? '',
                    estado_postulante: postulanteData?.id_estado_postulante ?? '',
                    comentario_entrevista: postulanteData?.comentario_entrevista ?? '',
                    fechaNacimiento: formatDate(postulanteData.fechaNacimiento),
                    departamento: postulanteData?.department_id ?? '',
                    provincia: postulanteData?.province_id ?? '',
                    distrito: postulanteData?.district_id ?? '',
                    direccion: postulanteData?.direccion ?? '',

                });

                setLocationData({
                    department: postulanteData?.department_id ?? '',
                    province: postulanteData?.province_id ?? '',
                    district: postulanteData?.district_id ?? '',
                    zone: "",
                });
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            if (error.response?.status === 404 && error.response?.data?.error === 'Postulante no encontrado') {
                navigate('/admin/reclutamiento');
                return;
            }
            console.error("Error al obtener el postulante:", error);
        }
    };

    const handleZoneChange = (value) => {
        setLocationData((prev) => ({
            ...prev,
            zone: value,
        }));
        // Sincronizar con form
        setForm((prev) => ({
            ...prev,
            region: value,
        }));
    };

    const dividirNombre = (nombreCompleto) => {
        if (!nombreCompleto || typeof nombreCompleto !== 'string') {
            return {
                nombre: '',
                apellidoPaterno: '',
                apellidoMaterno: '',
            };
        }

        const partes = nombreCompleto.trim().split(/\s+/);

        if (partes.length === 2) {
            return {
                nombre: partes[0],
                apellidoPaterno: partes[1],
                apellidoMaterno: '',
            };
        }

        if (partes.length === 3) {
            return {
                nombre: partes[0],
                apellidoPaterno: partes[1],
                apellidoMaterno: partes[2],
            };
        }

        if (partes.length >= 4) {
            return {
                nombre: partes.slice(0, 2).join(' '),
                apellidoPaterno: partes[2],
                apellidoMaterno: partes.slice(3).join(' '),
            };
        }

        // Caso por defecto
        return {
            nombre: partes[0] ?? '',
            apellidoPaterno: partes[1] ?? '',
            apellidoMaterno: partes.slice(2).join(' ') ?? '',
        };
    };

    const buscarCliente = async () => {
        try {
            if (!form.numeroDocumento || form.numeroDocumento.trim() === "") {
                setErrors((prev) => ({
                    ...prev,
                    numeroDocumento: "Ingrese un número válido",
                }));
                return;
            }

            const cliente = await ClienteService.buscarPorDocumento({
                token,
                tipoDocumento: form.tipoDocumento,
                numeroDocumento: form.numeroDocumento,
            });

            if (form.tipoDocumento === "1" && cliente) {
                setForm((prev) => ({
                    ...prev,
                    nombre: cliente.nombres,
                    apellidoMaterno: cliente.apellido_materno,
                    apellidoPaterno: cliente.apellido_paterno,

                }));
            }

            setErrors((prev) => ({
                ...prev,
                numeroDocumento: null,
            }));
        } catch (err) {
            const mensaje = err.response?.data?.error || err.message || "Error al consultar el servicio";
            setErrors((prev) => ({
                ...prev,
                numeroDocumento: mensaje,
            }));
        }
    }


    const handleNumericChange = (e) => {
        const { name, value } = e.target;
        const numericValue = validateNumericInput(value);
        setForm((prev) => ({
            ...prev,
            [name]: numericValue,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errores = validarFormulario();

        if (Object.keys(errores).length > 0) {
            setErrors(errores);
            return;
        }
        setLoading(true);
        try {
            const result = await PostulanteService.entrevistarPostulante(id, form, token);
            setLoading(false);
            setSuccess('Entrevista registrada correctamente');
            toast.success('Entrevista registrada correctamente');
            navigate('/admin/reclutamiento?tab=nuevo');
        } catch (err) {
            setError('Error al registrar entrevista');
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "edad") {
            // Solo permitir números
            if (!/^\d*$/.test(value)) return;
        }

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const validarFormulario = () => {
        const nuevosErrores = {};

        if (!form.tipoPostulacion) {
            nuevosErrores.tipoPostulacion = "El tipo de postulación es obligatorio";
        }

        if (!form.tipoDocumento) {
            nuevosErrores.tipoDocumento = "El tipo de documento es obligatorio";
        }

        if (form.numeroDocumento && !/^\d+$/.test(form.numeroDocumento)) {
            nuevosErrores.numeroDocumento = "Ingrese un número de documento válido";
        }

        if (!form.nombres || form.nombres.trim() === "") {
            nuevosErrores.nombres = "El nombre es obligatorio";
        }

        if (form.telefono && !/^\d{7,15}$/.test(form.telefono)) {
            nuevosErrores.telefono = "Ingrese un teléfono válido";
        }

        if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email)) {
            nuevosErrores.email = "Correo electrónico inválido";
        }

        if (form.edad && !/^\d+$/.test(form.edad)) {
            nuevosErrores.edad = "Ingrese una edad válida (solo números)";
        } else if (parseInt(form.edad) < 18 || parseInt(form.edad) > 100) {
            nuevosErrores.edad = "La edad debe estar entre 18 y 100 años";
        }

        if (!form.estado_postulante) {
            nuevosErrores.estado_postulante = "El estado del postulante es obligatorio";
        }

        if (!form.comentario_entrevista || form.comentario_entrevista.trim() === "") {
            nuevosErrores.comentario_entrevista = "El comentario de entrevista es obligatorio";
        }

        if (!form.departamento) nuevosErrores.department = " Departamento es Requerido";
        if (!form.provincia) nuevosErrores.provinces = " Provincia es Requerido";
        if (!form.distrito) nuevosErrores.districts = " Distrito es Requerido";

        return nuevosErrores;
    };

    return (
        <div className="ventas-admin-content">
            {loading && <Preloader />}
            <div className="breadcrumb-container">
                <span className="breadcrumb-link" onClick={handleBackToList}>
                    ← Listado de Postulantes
                </span>
                <span className="breadcrumb-current"> / Entrevista Postulante</span>
            </div>
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}
            <div className="dashboard-card nuevo-producto-card">
                <span className="nueva-venta-title"> Postulante # {id}</span>
                <form onSubmit={handleSubmit} className="nuevo-producto-form">
                    <div className="form-section">
                        <h3 className="section-title">Datos del Postulante</h3>
                        <div className="form-grid">
                            <div className="">
                                <label>Tipo de Postulación*</label>
                                <select
                                    name="tipoPostulacion"
                                    value={form.tipoPostulacion}
                                    onChange={handleChange}
                                    disabled
                                >
                                    <option value="">Selecciona tipo de postulación</option>
                                    {tiposPostulacion.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>
                                            {tipo.descripcion}
                                        </option>
                                    ))}
                                </select>
                                {errors.tipoPostulacion && (
                                    <span className="error">{errors.tipoPostulacion}</span>
                                )}
                            </div>
                            <div className="">
                                <label>Tipo de Documento </label>
                                <select
                                    name="tipoDocumento"
                                    value={form.tipoDocumento}
                                    onChange={handleChange}

                                >
                                    <option value="">Selecciona tipo de documento</option>
                                    {tiposDocumentos.map((tipo) => (
                                        <option key={tipo.id} value={tipo.id}>
                                            {tipo.description}
                                        </option>
                                    ))}
                                </select>
                                {errors.tipoDocumento && (
                                    <span className="error">{errors.tipoDocumento}</span>
                                )}
                            </div>
                        </div>
                        <div className="form-grid">
                            <div className="">
                                <label>Número de Documento </label>
                                <div className="input-with-button">
                                    <input
                                        type="text"
                                        name="numeroDocumento"
                                        value={form.numeroDocumento}
                                        onChange={handleNumericChange}
                                        placeholder="Solo números"
                                    />
                                    {(form.tipoDocumento == "1") && (
                                        <button
                                            type="button"
                                            className="search-btn-documento"
                                            title="Buscar cliente"
                                            onClick={buscarCliente}
                                        >
                                            <Search size={20} color="#555" />
                                        </button>
                                    )}
                                </div>
                                {errors.numeroDocumento && (
                                    <span className="error">{errors.numeroDocumento}</span>
                                )}
                            </div>
                            <div className="">
                                <label>Nombres*</label>
                                <input
                                    type="text"
                                    name="nombres"
                                    value={form.nombres}
                                    onChange={handleChange}
                                    placeholder="Nombres del Postulante"
                                />
                                {errors.nombres && <span className="error">{errors.nombres}</span>}
                            </div>
                        </div>
                        <div className="form-grid">
                            <div>
                                <label>Apellido paterno</label>
                                <input
                                    name="apellidoPaterno"
                                    value={form.apellidoPaterno}
                                    onChange={handleChange}

                                />
                            </div>
                            <div>
                                <label>Apellido materno</label>
                                <input
                                    name="apellidoMaterno"
                                    value={form.apellidoMaterno}
                                    onChange={handleChange}

                                />
                            </div>
                        </div>
                        <div className="form-grid">
                            <div className="">
                                <label>Teléfono* </label>
                                <input
                                    type="text"
                                    name="telefono"
                                    value={form.telefono}
                                    onChange={handleChange}
                                    placeholder="Teléfono"
                                />
                                {errors.telefono && (
                                    <span className="error">{errors.telefono}</span>
                                )}
                            </div>
                            <div className="">
                                <label>Correo Electrónico</label>
                                <input
                                    type="text"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    placeholder="Ingresa un Correo Electrónico"
                                />
                                {errors.email && (
                                    <span className="error">{errors.email}</span>
                                )}
                            </div>
                        </div>
                        <div className="form-grid">
                            <div className="">
                                <label>Edad </label>
                                <input
                                    type="text"
                                    name="edad"
                                    value={form.edad}
                                    onChange={handleChange}
                                    placeholder="Edad del Postulante"
                                />
                                {errors.edad && (
                                    <span className="error">{errors.edad}</span>
                                )}
                            </div>
                            <div className="">
                                <label>Fecha de Nacimiento</label>
                                <input
                                    type="date"
                                    name="fechaNacimiento"
                                    value={form.fechaNacimiento}
                                    onChange={handleChange}
                                />
                                {errors.fechaNacimiento && (
                                    <span className="error">{errors.fechaNacimiento}</span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="form-section">
                        <h3 className="section-title">Datos de Ubicación</h3>
                        <div style={{ gridColumn: "1 / -1" }}>

                            <LocationDropdowns
                                selectedDepartment={locationData.department}
                                selectedProvince={locationData.province}
                                selectedDistrict={locationData.district}
                                selectedZone={locationData.zone}
                                onDepartmentChange={handleDepartmentChange}
                                onProvinceChange={handleProvinceChange}
                                onDistrictChange={handleDistrictChange}
                                onZoneChange={handleZoneChange}
                                showZones={false}
                                className="location-dropdowns"
                                token={token}
                                errors={errors}
                            />
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                            <label>Dirección</label>
                            <textarea
                                name="direccion"
                                value={form.direccion}
                                onChange={handleChange}
                                placeholder="Ingrese la dirección completa"
                                rows={8}
                                style={{
                                    width: "100%",
                                    padding: "12px",
                                    fontSize: "14px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                    outline: "none",
                                    resize: "vertical",
                                    boxSizing: "border-box",
                                    backgroundColor: "white",
                                    transition: "border-color 0.3s ease",
                                }}
                                onFocus={(e) => (e.target.style.borderColor = "#3182ce")}
                                onBlur={(e) => (e.target.style.borderColor = "#ccc")}
                            />
                        </div>
                    </div>
                    <div className="form-section">
                        <h3 className="section-title">Datos de la Entrevista</h3>
                        <div className="form-group-compact">
                            <label>Comentario de Entrevista *</label>
                            <textarea
                                name="comentario_entrevista"
                                value={form.comentario_entrevista}
                                onChange={handleChange}
                                rows="3"
                                placeholder="Ingrese los comentarios de la entrevista..."
                            />
                            {errors.comentario_entrevista && (
                                <span className="error">{errors.comentario_entrevista}</span>
                            )}
                        </div>

                        <div className="form-group-compact">
                            <label>Estado *</label>
                            <select
                                id="estado_postulante"
                                name="estado_postulante"
                                value={form.estado_postulante}
                                onChange={handleChange}
                                className="filtro-select"
                            >
                                <option value="">Todos los estados</option>
                                {estados.map((estado) => (
                                    <option key={estado.id} value={estado.id}>
                                        {estado.descripcion}
                                    </option>
                                ))}
                            </select>
                            {errors.estado_postulante && (
                                <span className="error">{errors.estado_postulante}</span>
                            )}
                        </div>

                    </div>

                    <div className="form-actions">

                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Registrando..." : " Actualizar Postulante"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default EntrevistaForm;
